document.addEventListener('turbo:load', () => {
  const list = document.getElementById('featured-pages-sortable')
  const inputsContainer = document.getElementById('site_destaque_page_ids_order_inputs')
  if (!list || !inputsContainer) return

  function updateHiddenInputs() {
    inputsContainer.innerHTML = ''

    Array.from(list.children).forEach((item) => {
      const pageId = item.dataset.pageId
      if (!pageId) return

      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'site[destaque_page_ids_order][]'
      input.value = pageId
      inputsContainer.appendChild(input)
    })
  }

  function findDropTarget(mouseY) {
    let targetItem = null
    let targetOffset = null

    Array.from(list.children).forEach((item) => {
      if (item.classList.contains('dragging')) return

      const box = item.getBoundingClientRect()
      const offset = mouseY - box.top - box.height / 2

      if (offset < 0 && (targetOffset === null || offset > targetOffset)) {
        targetItem = item
        targetOffset = offset
      }
    })

    return targetItem
  }

  Array.from(list.children).forEach((item) => {
    item.draggable = true

    item.addEventListener('dragstart', () => {
      item.classList.add('dragging')
    })

    item.addEventListener('dragend', () => {
      item.classList.remove('dragging')
      updateHiddenInputs()
    })
  })

  list.addEventListener('dragover', (event) => {
    event.preventDefault()

    const draggingItem = list.querySelector('.dragging')
    if (!draggingItem) return

    const targetItem = findDropTarget(event.clientY)
    if (targetItem) {
      list.insertBefore(draggingItem, targetItem)
    } else {
      list.appendChild(draggingItem)
    }
  })

  updateHiddenInputs()
})
